import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../_services/index";
import { FormControl, FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  
  constructor(
    private authenticationService: AuthenticationService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.formInit();
  }
  
  formInit(): void {
    const emailPattern = "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?";
    this.loginForm = this.fb.group({
      email: [ '', [Validators.required, Validators.pattern(emailPattern), Validators.maxLength(40)] ],
      password: ['', [Validators.minLength(8), Validators.required]]
    });
  }
  
  login(form) {
    this.authenticationService.login(
      form['controls']['email']['value'],
      form['controls']['password']['value']
    );
  }

}
